import React from 'react';
import {
  Box,
  Typography,
  TextField,
} from '@mui/material';
import { SiteEditState } from '../../../../types/visualEditor';

interface CompanyInfoTabProps {
  editState: SiteEditState;
  updateEditState: (updates: Partial<SiteEditState>) => void;
}

export const CompanyInfoTab: React.FC<CompanyInfoTabProps> = ({ 
  editState, 
  updateEditState 
}) => (
  <Box sx={{ p: 2, width: '800px' }}>
    <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 600, mb: 2, fontSize: '18px' }}>
      会社情報
    </Typography>
    
    <Box sx={{ mb: 2 }}>
      <TextField
        fullWidth
        label="会社名"
        placeholder="(例: 株式会社○○)"
        variant="outlined"
        value={editState.settings?.companyInfo?.companyName || ''}
        onChange={(e) => updateEditState({
          settings: {
            ...editState.settings,
            companyInfo: {
              ...editState.settings?.companyInfo,
              companyName: e.target.value,
              description: editState.settings?.companyInfo?.description || '',
              address: editState.settings?.companyInfo?.address || '',
              website: editState.settings?.companyInfo?.website || ''
            }
          }
        })}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            backgroundColor: '#FFFFFF',
            '& fieldset': {
              borderColor: '#D0D0D0',
            },
          },
        }}
      />
    </Box>
    
    <Box sx={{ mb: 2 }}>
      <TextField
        fullWidth
        label="会社概要"
        multiline
        rows={4}
        placeholder="(例: 会社の概要を入力してください)"
        variant="outlined"
        value={editState.settings?.companyInfo?.description || ''}
        onChange={(e) => updateEditState({
          settings: {
            ...editState.settings,
            companyInfo: {
              ...editState.settings?.companyInfo,
              description: e.target.value,
              companyName: editState.settings?.companyInfo?.companyName || '',
              address: editState.settings?.companyInfo?.address || '',
              website: editState.settings?.companyInfo?.website || ''
            }
          }
        })}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            backgroundColor: '#FFFFFF',
            '& fieldset': {
              borderColor: '#D0D0D0',
            },
          },
        }}
      />
    </Box>
    
    <Box sx={{ mb: 2 }}>
      <TextField
        fullWidth
        label="住所"
        placeholder="(例: 東京都千代田区…)"
        variant="outlined"
        value={editState.settings?.companyInfo?.address || ''}
        onChange={(e) => updateEditState({
          settings: {
            ...editState.settings,
            companyInfo: {
              ...editState.settings?.companyInfo,
              address: e.target.value,
              companyName: editState.settings?.companyInfo?.companyName || '',
              description: editState.settings?.companyInfo?.description || '',
              website: editState.settings?.companyInfo?.website || ''
            }
          }
        })}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            backgroundColor: '#FFFFFF',
            '& fieldset': {
              borderColor: '#D0D0D0',
            },
          },
        }}
      />
    </Box>
    
    <Box sx={{ mb: 2 }}>
      <TextField
        fullWidth
        label="ウェブサイト"
        placeholder="(例: https://example.com)"
        variant="outlined"
        value={editState.settings?.companyInfo?.website || ''}
        onChange={(e) => updateEditState({
          settings: {
            ...editState.settings,
            companyInfo: {
              ...editState.settings?.companyInfo,
              website: e.target.value,
              companyName: editState.settings?.companyInfo?.companyName || '',
              description: editState.settings?.companyInfo?.description || '',
              address: editState.settings?.companyInfo?.address || ''
            }
          }
        })}
        sx={{
          '& .MuiOutlinedInput-root': {
            borderRadius: '12px',
            backgroundColor: '#FFFFFF',
            '& fieldset': {
              borderColor: '#D0D0D0',
            },
          },
        }}
      />
    </Box>
  </Box>
);
